import React from 'react'

import { Link, Text } from '@vividseats/vivid-ui-kit'
import NextLink from 'next/link'

import { CardWithImageGroupsData } from '@/types/app-types'

import { BEST_BROADWAY_COLUMNS, CHEAP_TICKETS_COLUMNS } from './constants'
import ProductionCardContainer from './production-card-container'
import styles from './styles.module.scss'

type Props = {
    cardWithImageGroups: CardWithImageGroupsData[]
    categoryImage: string | undefined
}

const BroadwayCards: React.FC<Props> = ({ cardWithImageGroups, categoryImage }) => {
    return (
        <div data-testid="broadway-cards">
            {cardWithImageGroups.map(({ title, subtitle, cta, productions }, index) => (
                <div key={title}>
                    <div className={styles.titleContainer} data-testid={`${title}-${index}`}>
                        <Text as="h3">{title}</Text>
                        <div className={styles.subtitleContainer}>
                            <Text as="p" className={styles.subtitle}>
                                {subtitle}
                            </Text>
                            {cta && (
                                <Link LinkComponent={NextLink} href={cta.link} size="base" importance="link-primary">
                                    {cta.title}
                                </Link>
                            )}
                        </div>
                    </div>
                    <ProductionCardContainer
                        containerTestId={`${title}-container`}
                        numberOfColumns={index === 0 ? BEST_BROADWAY_COLUMNS : CHEAP_TICKETS_COLUMNS}
                        productions={productions}
                        categoryImage={categoryImage}
                    />
                </div>
            ))}
            <br />
        </div>
    )
}

export default BroadwayCards
